import { render, staticRenderFns } from "./changeapp.vue?vue&type=template&id=5ec8a9c7&scoped=true"
import script from "./changeapp.vue?vue&type=script&lang=js"
export * from "./changeapp.vue?vue&type=script&lang=js"
import style0 from "./changeapp.vue?vue&type=style&index=0&id=5ec8a9c7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec8a9c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec8a9c7')) {
      api.createRecord('5ec8a9c7', component.options)
    } else {
      api.reload('5ec8a9c7', component.options)
    }
    module.hot.accept("./changeapp.vue?vue&type=template&id=5ec8a9c7&scoped=true", function () {
      api.rerender('5ec8a9c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/serve/changeapp.vue"
export default component.exports